/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import Pagination from '../../../components/Pagination/Pagination';
import Payment from '../../../components/Payment';
import ProgressCircle from '../../../components/ProgressCircle';
import firebase from 'firebase'

const LIMIT = 10;

export default function Payments() {
  const [loading, setLoading] = useState(false);
  const [totalItemCount, setTotalItemCount] = useState(0)
  const [data, setData] = useState([])
  const { page, type } = useParams()

  const loadContent = async () => {
    setLoading(true)
    try {
      const result = await firebase.functions().httpsCallable('getPayments')({
        page: parseInt(page || '1') - 1,
        limit: LIMIT,
        status: type
      });

      if (result.data.payments) {
        setData([...result.data.payments])
      } else {
        setData([])
      }

      if (result.data.count) {
        setTotalItemCount(result.data.count)
      } else {
        setTotalItemCount(0)
      }

    } catch (err) {
      console.log(err)
    }
    setLoading(false)
  }

  useEffect(() => {
    loadContent()
    return () => {
      // eslint-disable-next-line no-unused-expressions
      loadContent
    }
  }, [])

  if (loading) {
    return (
      <div style={{ width: 'max-content', margin: 'auto', marginTop: '42vh' }}>
        <ProgressCircle />
      </div>
    );
  }

  return (
    <div className="container-sm p-2">
      <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css"></link>
      <div className="gap-2 d-flex p-1 pt-0">
        <a href='/pay/to_pay' className={`btn ${(type === 'to_pay' || !type) ? 'btn-dark' : 'btn-light'}`}>To Pay</a>
        <a href='/pay/paid' className={`btn ${type === 'paid' ? 'btn-dark' : 'btn-light'}`}>Paid</a>
      </div>
      <div>
        {data?.map((payment, index) => {
          return <Payment
            key={payment.deliveryId}
            paid={type === 'paid'}
            refreshCallback={loadContent}
            data={{
              id: payment?.deliveryId,
              tags: payment?.tags || [],
              uid: payment?.uid,
              price: payment?.amount,
              fullUserName: payment?.fullUserName,
              username: payment?.username,
              bank_details: payment?.bankDetails,
              created_at: payment?.created_at
            }} />
        })}
        <Pagination total={totalItemCount} perPage={LIMIT} url={(type === 'to_pay' || !type) ? '/pay/to_pay' : '/pay/paid'} page={page || 1} />
      </div>
    </div>
  );
}
